import { errorSchema } from "@app/shared";
import type { ZodType } from "zod";

/**
 * Client HTTP du backend. Toutes les URL sont relatives : en production nginx sert
 * la SPA et proxifie /api vers le backend, donc meme origine et pas de CORS.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.code = code;
    this.status = status;
  }
}

export async function apiGet<T>(path: string, schema: ZodType<T>): Promise<T> {
  const response = await fetch(path, { headers: { accept: "application/json" } });
  const payload: unknown = await response.json().catch(() => null);

  if (!response.ok) {
    const parsed = errorSchema.safeParse(payload);
    throw new ApiError(
      parsed.success ? parsed.data.error.code : "http_error",
      parsed.success ? parsed.data.error.message : `Erreur HTTP ${response.status}`,
      response.status,
    );
  }

  const result = schema.safeParse(payload);
  if (!result.success) {
    throw new ApiError("contract_broken", "Reponse hors contrat", response.status);
  }
  return result.data;
}
